import styled from "styled-components";

const Wrapper = styled.div`
    .modalContent {
        font-size: 14px;
        padding: 0 20px;
    }
`;

export default Wrapper;
